
import React, { useState } from 'react';
import {
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Divider,
  Box,
} from '@mui/material';

import { AddCircleOutline } from '@mui/icons-material';
import { tokens } from '../theme/theme';

const PaymentTermForm = ({ open, onClose,terms,setTerms }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  

  const handleAddRow = () => {
    // setTerms([...terms, { name: '', days: '' }]);
    const newRowId = terms.length + 1;
    const newRow = { id: newRowId, description: '', status: 'Active', tdescription: '', tdays: 0 };
    setTerms([...terms, newRow]);
  };

  const handleSave = () => {
    // Save to API logic here
    console.log('Saved:', terms);
    onClose();
  };

  const handleInputChange = (index, field, value) => {
    const newTerms = [...terms];
    newTerms[index][field] = value;
    setTerms(newTerms);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          alignSelf: 'flex-start',
          margin: '0 auto',
          position: 'relative',
          top: '0px',
        },
      }}
      BackdropProps={{
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          paddingTop: '20px',
          minHeight: '100vh',
          background: 'rgba(0,0,0,0.5)',
        },
      }}
    >
      <DialogTitle style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
        Add Payment Term
      </DialogTitle>
      <Divider />
      <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>

        

<Box
  gridColumn="span 9"
  gridRow={"span 2"}
  alignItems="center"
  justifyContent="center"
  padding={1}
  sx={{
    "& .MuiTable-root": {
      border: "none",
      borderRadius: "10px",
      size: "small",
    },
    "& .MuiTableCell-root": {
      borderBottom: "none",
      border: "1px solid",
      borderRadius: "10px",
      borderColor: `${colors.primary[400]} !important`,
      padding: 0, // Removes padding within table cells
    },
    "& .name-column--cell": {
      color: colors.greenAccent[300],
    },
    "& .MuiTableHead-root": {
      borderBottom: "none",
      borderRadius: "10px",
    },
    "& .MuiTableBody-root": {
      overflowY: "auto",
    },
    "& .MuiCheckbox-root": {
      color: `${colors.blueAccent[200]} !important`,
      size: "small",
    },
    "& .MuiTableFooter-root": {
      borderTop: "none",
      height: "10px",
    },
    "& .MuiButton-text": {
      color: `${colors.grey[100]} !important`,
    },
  }}
>
  <TableContainer sx={{ borderRadius: "10px", overflow: "hidden" }}>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell style={{ color: colors.primary,textAlign:'center' }}>Terms Name</TableCell>
          <TableCell style={{ color: colors.primary ,textAlign:'center'}}>Number of Days</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {terms.map((term, index) => (
          <TableRow key={index}>
            <TableCell>
              <TextField
                value={term.tdescription}
                onChange={(e) => handleInputChange(index, 'tdescription', e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiInputBase-input': {
                    padding: '8px',
                    textAlign: 'left',
                  },
                }}
                variant="outlined"
                size="small"
                fullWidth
                style={{ color: colors.primary }}
              />
            </TableCell>
            <TableCell>
              <TextField
                type='number'
                value={term.tdays}
                onChange={(e) => handleInputChange(index, 'tdays', e.target.value)}
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '& .MuiInputBase-input': {
                    padding: '8px',
                    textAlign: 'right',
                  },
                }}
                size="small"
                fullWidth
                style={{ color: colors.primary }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>

  <Button
    size="small"
    variant="standard"
    color="secondary"
    startIcon={<AddCircleOutline sx={{color:colors.blueAccent[400]}} />}
    onClick={handleAddRow}
    style={{ marginTop: '10px',textTransform:'none' }}
  >
    Add New Term
  </Button>
</Box>

      </DialogContent>
      <DialogActions style={{ backgroundColor: colors.primary[400] }}>
        <Button size='small' variant="contained" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button size='small' variant="contained" color="secondary" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentTermForm;


